import React from 'react';
import { t } from 'ttag';

export default class Aszf extends React.Component {
  render() {
    return (
    <div className="row">
      <div className="col-md-6 offset-md-3 notfound-padding">
        <h2>{t`ÁSZF`}</h2>
        <p>Kialakítás alatt</p>
        <a href={"https://www.jegyezz.hu/"}>{t`Kezdőlap`}</a>
      </div>
    </div>
    );
  };
};